// extracted by mini-css-extract-plugin
export default {"arrow":"webpack-components-core-Popover-components-PopoverArrow-PopoverArrow-module__arrow"};